export const enum UserForgotPasswordViewStoreEvent {
  clickClose = 'click-close',
  clickCreateAccount = 'click-create-account',
}
